// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"401":"32304e77","452":"bc95b137","682":"81192d50"}[chunkId] + ".chunk.js";
};